import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Box, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import useUpdatePasswordFields from './useUpdatePasswordFields'
import Field from '@salesforce/retail-react-app/app/components/field'
import {pxToRem} from '../../../../utills/pxToRem'
import PasswordRequirements from '../../../../components/forms/password-requirements'
import {updatePasswordFieldsStyles} from './styles'

const UpdatePasswordFields = ({form, prefix = ''}) => {
    const fields = useUpdatePasswordFields({form, prefix})
    const password = form.watch('password')

    return (
        <Stack sx={updatePasswordFieldsStyles} spacing={0}>
            <Stack marginBottom={pxToRem(25)}>
                <Field {...fields.currentPassword} />
            </Stack>
            <Box
                height={pxToRem(1)}
                width="100%"
                borderBottom="1px solid"
                borderColor="black"
                opacity={'0.3'}
            />
            <Stack m={0} marginTop={`${pxToRem(15)} !important`}>
                <Field {...fields.password} />
                <PasswordRequirements value={password} />
            </Stack>
            <Stack marginTop={`${pxToRem(10)} !important`}>
                <Field {...fields.confirmPassword} />
            </Stack>
        </Stack>
    )
}

UpdatePasswordFields.propTypes = {
    form: PropTypes.object.isRequired,
    prefix: PropTypes.string
}

export default UpdatePasswordFields
